function activateColor(idSuffix, colorName, btnElement) {
  document.querySelectorAll('.ic-stage img').forEach(img => img.classList.remove('active'));
  
  // Update all instances of the bag image (for both AR and FR hidden/visible blocks)
  document.querySelectorAll('[id="bag-' + idSuffix + '"]').forEach(target => {
    target.classList.add('active');
  });

  // Update all instances of the title
  document.querySelectorAll('[id="ic-title"]').forEach(title => {
    title.innerText = colorName;
  });

  // Update button active states based on the clicked button's color/suffix
  document.querySelectorAll('.ic-btn').forEach(btn => btn.classList.remove('active'));
  // We can't just use btnElement because there are two copies of the buttons.
  // We find all buttons that have the onclick for this specific color.
  document.querySelectorAll('.ic-btn').forEach(btn => {
    if (btn.getAttribute('onclick') && btn.getAttribute('onclick').includes("'" + idSuffix + "'")) {
      btn.classList.add('active');
    }
  });
}
